// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';

/**
 * Inventory content documents wrapper component
 * Handles conditional rendering based on scan documents setting
 */
@Component({
    selector: 'inventory-content-documents-wrapper',
    template: `
        <inventory-content-pages
            *ngIf="scanDocument"
            icon="fas fa-file-alt"
            [headline]="'Documents'"
            selectedTabs="documents"
            [apiTypes]="['pdf', 'document']"
            monExport="inventory_document_pages,pages_documents,links_to_documents">
        </inventory-content-pages>
        <inventory-content-documents-no-scan *ngIf="!scanDocument"></inventory-content-documents-no-scan>
    `,
    standalone: false,
})
export class InventoryContentDocumentsWrapperComponent implements OnInit {
    public scanDocument: boolean = false;

    constructor (
        private sessionService: SessionService,
    ) {}

    ngOnInit (): void {
        this.scanDocument = this.sessionService.domain?.scan?.scan_documents || false;
    }
}
